import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box, Button, Hidden, Typography, withStyles } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { keyEmptyCheck } from 'aurora-utils/utils';
import classNames from 'classnames';
import { ADGMBreadcrumbs, ADGMImage, ADGMButton, Loading } from 'aurora-components';
import ApplicationJourney from './ApplicationJourney';
import LinearListing from './LinearListing';
import styles from './styles';

const ServiceDescription = props => {
  const {
    classes,
    history,
    breadCrumbs,
    serviceMeta,
    applicationType,
    handleNext,
    showPrevious,
    nextBtnContent,
    loading,
  } = props;
  if (!applicationType) return null;

  const locale = localStorage.getItem('lang');
  const isAr = locale === 'ar';

  return (
    <>
      {loading && <Loading />}
      <Box className={classes.main}>
        <Container className={classes.container}>
          <Box className={classes.navs}>
            <Hidden mdDown>
              <Box className={classes.breadcrumbsHolder}>
                <ADGMBreadcrumbs paths={breadCrumbs} />
              </Box>
            </Hidden>
            <Hidden mdUp>
              <Box className={classes.mobileTitlehead}>
                <Box>
                  <Link href='/app/services'>
                    <ADGMImage name='backArrowLong.svg' alt='croseimg' /> {keyEmptyCheck(serviceMeta?.title)}
                  </Link>
                </Box>
              </Box>
            </Hidden>
          </Box>
          <Box className={classNames([classes.serviceDetails, classes.sectionColumnTitle])}>
            <Hidden smDown>
              <Box className={classes.serviceTitle}>{keyEmptyCheck(serviceMeta?.title)}</Box>
            </Hidden>
            <Box className={classes.serviceDescription}>
              <Box>
                <Typography component='h2'>{keyEmptyCheck('service_description')}</Typography>
              </Box>

              <Box>
                <Typography component='p'>{keyEmptyCheck(serviceMeta?.description)}</Typography>
              </Box>
              {/* {applicationType === 'register-easement' && (
                <>
                  <Box>
                    <Typography component='p'>{keyEmptyCheck('register_easement_description_a')}</Typography>
                  </Box>
                  <Box>
                    <Typography component='p'>{keyEmptyCheck('register_easement_description_b')}</Typography>
                  </Box>
                  <Box>
                    <Typography component='p'>{keyEmptyCheck('register_easement_description_c')}</Typography>
                  </Box>
                </>
              )} */}
            </Box>
          </Box>
          <ApplicationJourney classes={classes} applicationJourney={serviceMeta?.applicationJourney} />
          {/* {isTransferOffplanToComplete && (
            <LinearListing
              classes={classes}
              title={keyEmptyCheck('property_type')}
              data={[
                {
                  icon: 'building.svg',
                  value: keyEmptyCheck('residential_commercial'),
                },
              ]}
            />
          )}
          {isProjectRegistration && (
            <LinearListing
              classes={classes}
              title={keyEmptyCheck('project_type')}
              data={[
                {
                  icon: 'building.svg',
                  value: keyEmptyCheck(registrationType === 'READY' ? 'completed_projects' : 'off_plan_projects'),
                },
              ]}
            />
          )} */}
          <LinearListing
            classes={classes}
            title={keyEmptyCheck('required_documents')}
            data={serviceMeta?.documents?.map(doc => {
              return {
                icon: 'document_gold.svg',
                value: keyEmptyCheck(doc),
              };
            })}
          />
          <LinearListing
            classes={classes}
            title={keyEmptyCheck('transfer_of_interest_adgm_fees')}
            data={serviceMeta?.transferOfInterestADGMFees}
          />

          <LinearListing classes={classes} title={keyEmptyCheck('ADGM_fees')} data={serviceMeta?.adgmFees} />
          <LinearListing classes={classes} title={keyEmptyCheck('ADRES_fees')} data={serviceMeta?.adresFees} />

          <LinearListing
            classes={classes}
            title={keyEmptyCheck('mortgage_services_adgm_fees')}
            data={serviceMeta?.mortgageServicesADGMFees}
          />
          <LinearListing
            classes={classes}
            title={keyEmptyCheck('approximate_time_to_submit')}
            data={[
              {
                icon: 'clock_gold.svg',
                value: keyEmptyCheck('t_min', {
                  m: serviceMeta?.approximateTime,
                }),
              },
            ]}
          />
          <Box className={classNames([classes.nextprevBtnholder, isAr && classes.rotateArrow])}>
            <Container className={classNames('MuiContainer-maxWidthLg', classes.reviewActionsWrapper)}>
              <Box className={classNames('MuiContainer-maxWidthLg', classes.buttonSection)}>
                {showPrevious ? (
                  <ADGMButton onClick={() => history.goBack()} variant='tertiary'>
                    <ADGMImage name='backArrowLong.svg' alt='back-arrow-btn' />
                    {keyEmptyCheck('previous')}
                  </ADGMButton>
                ) : (
                  <Button onClick={() => history.goBack()} className={classNames([classes.backButton])}>
                    {keyEmptyCheck('cancel')}
                  </Button>
                )}
                <Button
                  disabled={loading}
                  variant='contained'
                  color='primary'
                  onClick={handleNext}
                  className={classes.nextbtn}
                >
                  {keyEmptyCheck(nextBtnContent)}
                  <ADGMImage name='NextArrow.png' alt='next-arrow-btn' />
                </Button>
              </Box>
            </Container>
          </Box>
        </Container>
      </Box>
    </>
  );
};

ServiceDescription.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleNext: PropTypes.func.isRequired,
  showPrevious: PropTypes.bool,
  nextBtnContent: PropTypes.string,
  breadCrumbs: PropTypes.array.isRequired,
  serviceMeta: PropTypes.array.isRequired,
  applicationType: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

ServiceDescription.defaultProps = {
  showPrevious: false,
  nextBtnContent: 'initiate_application',
};

export default withStyles(styles)(ServiceDescription);
